import { DbgPaths } from "../../../../../utils/Paths"
import React from "react"
import { FormattedMessage } from "react-intl"
import { Link, UnorderedListItem } from "@carrotfertility/carotene-core"
import useBenefit from "../../../../dynamic-content/hooks/useGetBenefit"
import { CategorySections } from "../PayingForCareModal"

const MedicationsHeader = (): JSX.Element => {
  return (
    <p>
      <FormattedMessage defaultMessage="This category includes eligible medications for the following journeys:" />
    </p>
  )
}

const MedicationListItems = (): JSX.Element => {
  const { data: benefitInfo } = useBenefit()
  const { journeys, sprints } = benefitInfo
  return (
    <>
      {journeys.fertilityCare.eligibleExpensesDetail.isRxCovered && (
        <UnorderedListItem>
          <FormattedMessage
            defaultMessage="<link>Fertility care</link>"
            values={{
              link: (linkContent) => (
                <Link target="_blank" href={DbgPaths.FERTILITY_COVERAGE}>
                  {linkContent}
                </Link>
              )
            }}
          />
        </UnorderedListItem>
      )}
      {journeys.fertilityPreservation.eligibleExpensesDetail.isRxCovered && (
        <UnorderedListItem>
          <FormattedMessage
            defaultMessage="<link>Fertility preservation</link>"
            values={{
              link: (linkContent) => (
                <Link target="_blank" href={DbgPaths.PRESERVATION_COVERAGE}>
                  {linkContent}
                </Link>
              )
            }}
          />
        </UnorderedListItem>
      )}
      {sprints?.enabled && sprints?.fertilityCare?.enabled && sprints?.fertilityCare?.telemedicine?.enabled && (
        <UnorderedListItem>
          <FormattedMessage
            defaultMessage="<link>Metabolic-fertility health</link>"
            values={{
              link: (linkContent) => (
                <Link target="_blank" href={DbgPaths.FERTILITY_COVERAGE}>
                  {linkContent}
                </Link>
              )
            }}
          />
        </UnorderedListItem>
      )}
      {journeys.gestationalCarrier?.eligibleExpensesDetail?.isRxCovered && (
        <UnorderedListItem>
          <FormattedMessage
            defaultMessage="<link>Gestational surrogacy</link>"
            values={{
              link: (linkContent) => (
                <Link target="_blank" href={DbgPaths.GESTATIONAL_SURROGACY_COVERAGE}>
                  {linkContent}
                </Link>
              )
            }}
          />
        </UnorderedListItem>
      )}
      {journeys.menopause.hasEligibleExpenses && (
        <UnorderedListItem>
          <FormattedMessage
            defaultMessage="<link>Menopause</link>"
            values={{
              link: (linkContent) => (
                <Link target="_blank" href={DbgPaths.MENOPAUSE}>
                  {linkContent}
                </Link>
              )
            }}
          />
        </UnorderedListItem>
      )}
      {journeys.lowTestosterone.hasEligibleExpenses && (
        <UnorderedListItem>
          <FormattedMessage
            defaultMessage="<link>Low testosterone</link>"
            values={{
              link: (linkContent) => (
                <Link target="_blank" href={DbgPaths.LOW_TESTOSTERONE}>
                  {linkContent}
                </Link>
              )
            }}
          />
        </UnorderedListItem>
      )}
      {journeys.genderAffirmingCare.hasEligibleExpenses && (
        <UnorderedListItem>
          <FormattedMessage
            defaultMessage="<link>Gender-affirming care</link>"
            values={{
              link: (linkContent) => (
                <Link target="_blank" href={DbgPaths.GENDER_AFFIRMING_CARE}>
                  {linkContent}
                </Link>
              )
            }}
          />
        </UnorderedListItem>
      )}
    </>
  )
}

const MedicationsFooter = (): JSX.Element => {
  const { data: benefitInfo } = useBenefit()
  const carrotRx = benefitInfo.carrotRx

  return (
    <p>
      {carrotRx.isCarrotRxRequired ? (
        <FormattedMessage
          defaultMessage="To be covered, all medications must be prescribed by an <linkOne>eligible provider</linkOne> and filled through <linkTwo>Carrot Rx</linkTwo>."
          values={{
            linkOne: (linkContent) => (
              <Link target="_blank" href={DbgPaths.PROVIDER_ELIGIBILITY}>
                {linkContent}
              </Link>
            ),
            linkTwo: (linkContent) => (
              <Link target="_blank" href={DbgPaths.PHARMACY}>
                {linkContent}
              </Link>
            )
          }}
        />
      ) : (
        <FormattedMessage
          defaultMessage="To be covered, all medications must be prescribed by an <link>eligible provider</link>."
          values={{
            link: (linkContent) => (
              <Link target="_blank" href={DbgPaths.PROVIDER_ELIGIBILITY}>
                {linkContent}
              </Link>
            )
          }}
        />
      )}
    </p>
  )
}

export function getMedicationCategorySections(): CategorySections {
  return {
    header: <MedicationsHeader />,
    listItems: <MedicationListItems />,
    footer: <MedicationsFooter />
  }
}
